import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import { SessionWhatsAppService } from '../session-whatsapp.service';

export const useGetSessionWhatsAppNotifications = (
	params: SessionWhatsApp.ListParams,
	options?: Omit<
		UseQueryOptions<SessionWhatsApp.ListResponse, Error>,
		'queryKey' | 'queryFn'
	>,
) => {
	return useQuery({
		queryKey: ['session-whatsapp', params],
		queryFn: () => SessionWhatsAppService.get(params),
		refetchOnWindowFocus: false,
		...options,
	});
};

export const useGetSessionWhatsAppNotification = (
	id: string,
	options?: Omit<
		UseQueryOptions<SessionWhatsApp.SessionWhatsAppNotification, Error>,
		'queryKey' | 'queryFn'
	>,
) => {
	return useQuery({
		queryKey: ['session-whatsapp', id],
		queryFn: () => SessionWhatsAppService.getById(id),
		enabled: !!id,
		refetchOnWindowFocus: false,
		...options,
	});
};
